import { getItemAction } from "./baseActions";

export const getFieldOptionsAction = (fieldName: string) => {
    return getItemAction({
        url: `/cms/api/config/field-options/${fieldName}`,
    });
}
